"use client";

import { c as _c } from "react/compiler-runtime";
import { useAIChatMessageContext } from "../contexts";
import { AgentPlan } from "@/app/[tenant]/(console)/analytics/ask/components/agent-plan";
import { AnalyticsArtifactRenderer } from "@/app/[tenant]/(console)/analytics/ask/components/analytics-artifact-renderer";
import { AnalyticsResultType } from "@/components/ai-chat/types";
interface AIChatMessageAnalyticsProps {
  className?: string;
}
export function AIChatMessageAnalytics(t0) {
  const $ = _c(11);
  const {
    className
  } = t0;
  const {
    message
  } = useAIChatMessageContext();
  if (!message.analyticsResult && !message.analyticsSteps?.length) {
    return null;
  }
  let t1;
  if ($[0] !== message.analyticsResult?.python_code || $[1] !== message.analyticsResult?.search_context || $[2] !== message.analyticsResult?.sql || $[3] !== message.analyticsSteps) {
    t1 = message.analyticsSteps && message.analyticsSteps.length > 0 && <AgentPlan steps={message.analyticsSteps} sql={message.analyticsResult?.sql} pythonCode={message.analyticsResult?.python_code} searchContext={message.analyticsResult?.search_context} defaultCollapsed={true} />;
    $[0] = message.analyticsResult?.python_code;
    $[1] = message.analyticsResult?.search_context;
    $[2] = message.analyticsResult?.sql;
    $[3] = message.analyticsSteps;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== message.analyticsResult) {
    t2 = message.analyticsResult && message.analyticsResult.result_type !== AnalyticsResultType.QUESTION && <AnalyticsArtifactRenderer result={message.analyticsResult} />;
    $[5] = message.analyticsResult;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== className || $[8] !== t1 || $[9] !== t2) {
    t3 = <div className={className}>{t1}{t2}</div>;
    $[7] = className;
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
}